import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from '@irb/app.service';
import { PageService } from '@irb-common/services/page.service'; 
import { IrbDashboardService } from '@irb/irb-dashboard/irb-dashboard.service';
import { ICashAnalysisDetails } from '@irb/irb-dashboard/irb-dashboard.model';
import { AnalyticsService } from '@irb/irb-common/analytics/analytics.service';

@Component({ standalone: false,
  selector: 'irb-com-cash-analysis',
  templateUrl: './com-cash-analysis.component.html',
  styleUrls: ['./com-cash-analysis.component.scss']
})
export class ComCashAnalysisComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  private _data: ICashAnalysisDetails;
  chartData: any;
  colors: Array<string> = [
    "#EE0000",
    "#FF8800",
    "#3C842B"
  ];

  options: any = {
    responsive: true,
    maintainAspectRatio: false,

    circumference: 180,
    rotation: 270,
    cutoutPercentage: 50,
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      }
    }
  };

  constructor(
    public as: AppService,
    public ps: PageService, 
    private dbs: IrbDashboardService, 
    private cdr: ChangeDetectorRef, 
    private router: Router,
    private ats: AnalyticsService
  ) {}

  ngOnInit() {
    this.ps.getUserDetails().pipe(takeUntil(this.destroyed$)).subscribe((d) => {   
      if(d) {
        this.dbs.getCashAnalysisDetails().pipe(takeUntil(this.destroyed$)).subscribe((d) => {
          this.data = d as ICashAnalysisDetails;
          this.update();
          this.cdr.detectChanges();
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  update() {
    const a = (this.data.inShortFallCount / this.data.totalAccounts) * 100;
    const b = (this.data.inExcessCount / this.data.totalAccounts) * 100;
    const c = (this.data.inRangeCount / this.data.totalAccounts) * 100;
    const t = a + b + c;

    this.chartData = {
      datasets: [
          {
              data: (t > 0) ? [a,b,c] : [100],
              backgroundColor: (t > 0) ? this.colors : ["#CECECE"],
              hoverBackgroundColor: (t > 0) ? this.colors : ["#CECECE"],
              borderWidth: 2,
              hoverBorderColor: ["#FFFFFF"]
          }
      ]
    };
  }

  showCashReport() {
    this.ats.trackClickEvent("lc_cashreport");
    this.router.navigate(['/reports/cash-report']);
  }

  showCashReportWithCashInRange() {
    this.ats.trackClickEvent("lc_inrange");
    this.as.setToSession("CASH_REPORT_STATUS_FILTER_DEFAULT","In Range "+"("+this.data.inRangeCount+")");
    this.router.navigate(['/reports/cash-report']);
  }

  showCashReportWithCashShortFall() {
    this.ats.trackClickEvent("lc_shortfall");
    this.as.setToSession("CASH_REPORT_STATUS_FILTER_DEFAULT","Shortfall "+"("+this.data.inShortFallCount+")");
    this.router.navigate(['/reports/cash-report']);
  }

  showCashReportWithCashInExcess() {
    this.ats.trackClickEvent("lc_excess");
    this.as.setToSession("CASH_REPORT_STATUS_FILTER_DEFAULT","Excess "+"("+this.data.inExcessCount+")");
    this.router.navigate(['/reports/cash-report']);
  }

  get data() {
    return this._data;
  }

  set data(d: ICashAnalysisDetails) {
    this._data = d;
  }
}
